/**
 * Date Picker Component
 * ---------------------
 * This component provides a date picker interface for selecting dates. It emits events for date selection, cancellation,
 * and confirmation. The selected date is formatted to ISO string format.
 *
 * Features:
 * - Displays a date picker for selecting dates.
 * - Emits events for date selection, cancellation, and confirmation.
 * - Formats the selected date to ISO string format.
 */

import {
  Component,
  OnChanges,
  SimpleChanges,
  Input,
  Output,
} from '@angular/core';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.css'],
})
export class DatePickerComponent implements OnChanges {
  @Input() startDate!: string | null; // Input property for the initial start date
  @Output() dateSelected = new EventEmitter<string>(); // Output event emitter for date selection
  @Output() cancelDatePicker = new EventEmitter<boolean>(); // Output event emitter for date picker cancellation
  @Output() confirmSelectedDate = new EventEmitter<void>(); // Output event emitter for date confirmation

  public formattedStartDate: string | null | undefined = undefined; // Formatted start date

  /**
   * Lifecycle hook that is called when any data-bound property of a directive changes.
   * Updates the formatted start date based on the changes.
   * @param changes - Object of SimpleChanges containing the changed properties
   */
  ngOnChanges(changes: SimpleChanges): void {
    if ('startDate' in changes) {
      const startDate = changes['startDate'].currentValue;
      if (startDate === null) {
        this.formattedStartDate = undefined;
      } else {
        this.formattedStartDate = new Date(startDate).toISOString();
      }
    }
  }

  /**
   * Emits an event with the selected date.
   * @param date - The selected date
   */
  public onDateSelected(date: string): void {
    this.dateSelected.emit(date);
  }


    /**
   * Emits an event to cancel the date picker.
   */
  public onCancelDatePicker(): void {
    this.cancelDatePicker.emit(true);
  }

   /**
   * Emits an event to confirm the selected date.
   */
  public onConfirmSelectedDate(): void {
    this.confirmSelectedDate.emit();
  }
}
